import { FB_Template, Quarter } from '@algomusinc/domain';
import { EventEmitter } from '@angular/core';
import { addCommas } from './addCommas';
import { calculateAttachRateMeasureGDP } from './calculateAttachRateMeasureGDP';
import { calculateAttachRateMeasureRDP } from './calculateAttachRateMeasureRDP';
import { mapCummulatedObject, mapCummulatedObjectAg } from './mapCummulatedObject';


export const collapseQuarter = (
  quarter: Quarter | any,
  measureKeys: Array<string>,
  parentKey: string,
  forecastKeys: Array<string>,
  spreadEqualMeasures: Array<string>,
  lowHeirarichyMeasures: Array<string>,
  calculateMeasures: EventEmitter<any>,
  calcPctMeasures: Array<string>,
  fbTemplateId: number
) => {
      quarter.monthList.forEach((month: any) => {
        measureKeys.forEach((key) => {
          if (key.indexOf('Comment') < 0) {
            month.measures[key] = 0;
            quarter.measures[key] = 0;
          } else {
            month.measures[key] = '';
            quarter.measures[key] = '';
          }
        });
      });
      quarter.monthList.forEach((month: any) => {
        month.weekList.forEach((week: any) => {
          measureKeys.forEach((key) => {
            mapCummulatedObject(
              month,
              key,
              week,
              parentKey,
              spreadEqualMeasures,
              lowHeirarichyMeasures
            );
            mapCummulatedObject(
              quarter,
              key,
              week,
              parentKey,
              spreadEqualMeasures,
              lowHeirarichyMeasures
            );
          });
        });
      });
      quarter.monthList.forEach((month: any) => {
        measureKeys.forEach((key) => {
          if (key.indexOf('Pct') > 0 && !calcPctMeasures.includes(key)) {
            quarter['measures'][key] = quarter.monthList.every(
              (row: any) => row['measures'][key] == quarter['measures'][key]
            )
              ? quarter['measures'][key]
              : 'Multiple %';
            month['measures'][key] = month.weekList.every(
              (row: any) => row['measures'][key] == month['measures'][key]
            )
              ? month['measures'][key]
              : 'Multiple %';
          } else if (calcPctMeasures.includes(key)) {
            if (fbTemplateId === FB_Template.Global_Planning) {
              calculateAttachRateMeasureGDP(quarter);
            } else if (fbTemplateId === FB_Template.Regional_Planning) {
              calculateAttachRateMeasureRDP(quarter);
            }
          }
          if (key.indexOf('Comment') > 0) {
            month['measures'][key] = month.weekList.every(
              (row: any) => row['measures'][key] == month['measures'][key]
            )
              ? month['measures'][key]
              : 'Multiple Comments';
            quarter['measures'][key] = quarter.monthList.every(
              (row: any) => row['measures'][key] == quarter['measures'][key]
            )
              ? quarter['measures'][key]
              : 'Multiple Comments';
          }
          if (
            key.indexOf('Comment') < 0 &&
            !spreadEqualMeasures.includes(key)
          ) {
            month['measures'][key] = month['measures'][key]

              .toString()
              .replace(/,/g, '');

            quarter['measures'][key] = quarter['measures'][key]

              .toString()
              .replace(/,/g, '');
            addCommas(quarter.measures, key);
            addCommas(month.measures, key);
            month.weekList.forEach((week: any) => {
              addCommas(week.measures, key);
            });
          }
        });
      });
  return quarter;
};
export const collapseQuarterAg = (
  quarter: Quarter | any,
  measureKeys: Array<string>,
  parentKey: string,
  forecastKeys: Array<string>,
  spreadEqualMeasures: Array<string>,
  lowHeirarichyMeasures: Array<string>,
  calculateMeasures: EventEmitter<any>,
  calcPctMeasures: Array<string>,
  fbTemplateId: number,
  fbForecastMIVResponseModelKey: any,
  transformMeasureKeys: Array<string>,
  multipleAggregatedMeasures: Array<string>,
  masterMeasureList: Array<any>
): any => {
  if([FB_Template.Multi_ItemView, FB_Template.Customer_Order_Planner, FB_Template.REPL_PLANNER, FB_Template.PP_Planner].includes(fbTemplateId)){
    quarter = collapseMivQuarterAg(
      quarter,
      measureKeys,
      parentKey,
      forecastKeys,
      spreadEqualMeasures,
      lowHeirarichyMeasures,
      calculateMeasures,
      calcPctMeasures,
      fbTemplateId,
      fbForecastMIVResponseModelKey,
      transformMeasureKeys,
      multipleAggregatedMeasures
    );
  }else{
    let avgCount = 0;
    quarter.monthList.forEach((month: any) => {
      measureKeys.forEach((key: any) => {
        if (key.indexOf('Comment') < 0) {
          month[parentKey][key] = 0;
          quarter[parentKey][key] = 0;
        } else {
          month[parentKey][key] = '';
          quarter[parentKey][key] = '';
        }
      });
    });
    quarter.monthList.forEach((month: any) => {
      month.weekList.forEach((week: any) => {
        measureKeys.forEach((key: any) => {
          mapCummulatedObjectAg(
            month,
            key,
            week,
            parentKey,
            spreadEqualMeasures,
            lowHeirarichyMeasures
          );
          mapCummulatedObjectAg(
            quarter,
            key,
            week,
            parentKey,
            spreadEqualMeasures,
            lowHeirarichyMeasures
          );
        });
        avgCount = avgCount + 1;
      });
    });
    measureKeys.forEach(key => {
      if(transformMeasureKeys.includes(key) && key.indexOf('Pct')<0){
        let selectedMeasure = masterMeasureList.find((e:any)=>e.code == key);
        if(selectedMeasure.measureTypeId == 3){
          quarter[parentKey][key] = Number(quarter[parentKey][key]/avgCount);
        }
      }
    });
    quarter.monthList.forEach((month: any) => {
      measureKeys.forEach((key: any) => {
        if (
          month[parentKey][key] == undefined ||
          quarter[parentKey][key] == undefined
        )
          return;

        if (key.indexOf('Pct') > 0 && (!calcPctMeasures.includes(key) || fbTemplateId == 5)) {
          let transformMeasureCondition = false;
          if(fbTemplateId == 5){
            if(key.indexOf('--') > 0){
              let measureKey = key.split('--');
              if(measureKey && measureKey.length > 0){
                transformMeasureCondition = transformMeasureKeys?.includes(measureKey[0]);
              }
            }else{
              transformMeasureCondition =  transformMeasureKeys?.includes(key)
            }
          }else{
            transformMeasureCondition =  transformMeasureKeys?.includes(key)
          }
          if(transformMeasureCondition){
            quarter[parentKey][key] = 0;
            let avgCount = 0;
            quarter.monthList.forEach((month: any) =>
            {
              month.weekList.forEach((week: any) =>
              {
                quarter[parentKey][key] = +week[parentKey][key] + quarter[parentKey][key];
                avgCount = avgCount + 1;
              });
            });
            quarter[parentKey][key] = Number((quarter[parentKey][key]/(avgCount)).toFixed(2));
          }else{
            quarter[parentKey][key] = quarter.monthList.every(
              (row: any) => row[parentKey][key] == quarter[parentKey][key]
            )
              ? quarter[parentKey][key]
              : 'Multiple %';
            month[parentKey][key] = month.weekList.every(
              (row: any) => row[parentKey][key] == month[parentKey][key]
            )
              ? month[parentKey][key]
              : 'Multiple %';
          }
        }  else if (calcPctMeasures.includes(key)  && fbTemplateId != 5) {
          if (fbTemplateId === FB_Template.Global_Planning) {
            calculateAttachRateMeasureGDP(quarter);
            calculateAttachRateMeasureRDP(quarter);
          } else if (fbTemplateId === FB_Template.Regional_Planning) {
            calculateAttachRateMeasureRDP(quarter);
            calculateAttachRateMeasureGDP(quarter);
          }
        }
        if (key.indexOf('Comment') > 0) {
          month[parentKey][key] = month.weekList.every(
            (row: any) => row[parentKey][key] == month[parentKey][key]
          )
            ? month[parentKey][key]
            : ['PromoIndicatorComments', 'LYPromoIndicatorComments', 'PromoDetailsComments'].includes(key) ? 'See Details' : 'Multiple Comments';
          quarter[parentKey][key] = quarter.monthList.every(
            (row: any) => row[parentKey][key] == quarter[parentKey][key]
          )
            ? quarter[parentKey][key]
            : ['PromoIndicatorComments', 'LYPromoIndicatorComments', 'PromoDetailsComments'].includes(key) ? 'See Details' : 'Multiple Comments';
        }
        if (key.indexOf('Comment') < 0 && !spreadEqualMeasures.includes(key)) {
          month[parentKey][key] = month[parentKey][key]
          quarter[parentKey][key] = quarter[parentKey][key]
        }
      });
    });
  }
  return quarter;
};
function collapseMivQuarterAg(
  quarter: Quarter,
  measureKeys: Array<string>,
  parentKey: string,
  forecastKeys: Array<string>,
  spreadEqualMeasures: Array<string>,
  lowHeirarichyMeasures: Array<string>,
  calculateMeasures: EventEmitter<any>,
  calcPctMeasures: Array<string>,
  fbTemplateId: number,
  fbForecastMIVResponseModelKey: any,
  transformMeasureKeys: Array<string>,
  multipleAggregatedMeasures: Array<string>
){
  quarter.monthList.forEach((month: any) => {
    month[fbForecastMIVResponseModelKey] = JSON.parse(JSON.stringify([...month.weekList[0][fbForecastMIVResponseModelKey]]));
    quarter[fbForecastMIVResponseModelKey] = JSON.parse(JSON.stringify([...month[fbForecastMIVResponseModelKey]]));
    measureKeys.forEach((key: any) => {
      if(month[fbForecastMIVResponseModelKey] && month[fbForecastMIVResponseModelKey].length>0){
        for(let index = 0; index < month[fbForecastMIVResponseModelKey].length; index++){
          if (key.indexOf('Comment') < 0) {
            month[fbForecastMIVResponseModelKey][index][parentKey][key] = 0;
            // @ts-ignore
            quarter[fbForecastMIVResponseModelKey][index][parentKey][key] = 0;
          } else {
            month[fbForecastMIVResponseModelKey][index][parentKey][key] = '';
            // @ts-ignore
            quarter[fbForecastMIVResponseModelKey][index][parentKey][key] = '';
          }
        }
      }
    });
  });
  let avgCount = 0;
  quarter.monthList.forEach((month: any) => {
    month.weekList.forEach((week: any) => {
      for(let index = 0; index < week[fbForecastMIVResponseModelKey].length; index++){
        measureKeys.forEach((key: any) => {
          // @ts-ignore
          if(quarter[fbForecastMIVResponseModelKey] && quarter[fbForecastMIVResponseModelKey].length>0){
            mapCummulatedObjectAg(
              month[fbForecastMIVResponseModelKey][index],
              key,
              week[fbForecastMIVResponseModelKey][index],
              parentKey,
              spreadEqualMeasures,
              lowHeirarichyMeasures,
              multipleAggregatedMeasures
            );
            mapCummulatedObjectAg(
              quarter[fbForecastMIVResponseModelKey][index],
              key,
              week[fbForecastMIVResponseModelKey][index],
              parentKey,
              spreadEqualMeasures,
              lowHeirarichyMeasures,
              multipleAggregatedMeasures
            );
          }
        });
      }
      avgCount = avgCount + 1;
    });
  });
  measureKeys.forEach(key => {
    if(transformMeasureKeys.includes(key) && key.indexOf('Pct') < 0){
      for (let index = 0; index < 20; index++) {
        quarter[fbForecastMIVResponseModelKey][index][parentKey][key] = Number(quarter[fbForecastMIVResponseModelKey][index][parentKey][key]/avgCount);
      }
    }
  });
  // @ts-ignore
  if(quarter[fbForecastMIVResponseModelKey] && quarter[fbForecastMIVResponseModelKey].length>0){
    for(let index = 0; index< quarter[fbForecastMIVResponseModelKey]?.length; index++){
      quarter.monthList.forEach((month: any) => {
        measureKeys.forEach((key: any) => {
          // @ts-ignore
          if (month[fbForecastMIVResponseModelKey][index][parentKey][key] == undefined || quarter[fbForecastMIVResponseModelKey][index][parentKey][key] == undefined) return;
          if (key.indexOf('Pct') > 0 && !calcPctMeasures.includes(key)) {
            if(transformMeasureKeys && transformMeasureKeys.length > 0 && transformMeasureKeys.includes(key)){
              quarter[fbForecastMIVResponseModelKey][index][parentKey][key] = 0;
              let avgCount = 0;
              quarter.monthList.forEach((month:any) => {
                month.weekList.forEach((week:any)=>{
                  quarter[fbForecastMIVResponseModelKey][index][parentKey][key] = +week[fbForecastMIVResponseModelKey][index][parentKey][key] + quarter[fbForecastMIVResponseModelKey][index][parentKey][key];
                  avgCount = avgCount + 1;
                });
              });
              quarter[fbForecastMIVResponseModelKey][index][parentKey][key] = Number((quarter[fbForecastMIVResponseModelKey][index][parentKey][key]/avgCount).toFixed(2));
            }else{
              // @ts-ignore
              quarter[fbForecastMIVResponseModelKey][index][parentKey][key] = quarter.monthList.every(// @ts-ignore
                (row: any) => row[fbForecastMIVResponseModelKey][index][parentKey][key] == quarter[fbForecastMIVResponseModelKey][index][parentKey][key]
              )// @ts-ignore
                ? quarter[fbForecastMIVResponseModelKey][index][parentKey][key]
                : 'Multiple %';
              month[fbForecastMIVResponseModelKey][index][parentKey][key] = month.weekList.every(// @ts-ignore
                (row: any) => month[fbForecastMIVResponseModelKey][index][parentKey][key] == row[fbForecastMIVResponseModelKey][index][parentKey][key]
              ) ? month[fbForecastMIVResponseModelKey][index][parentKey][key] : 'Multiple %';
            }
          }
          if (key.indexOf('Comment') > 0) {
            // @ts-ignore
            quarter[fbForecastMIVResponseModelKey][index][parentKey][key] = quarter.monthList.every(// @ts-ignore
              (row: any) => row[fbForecastMIVResponseModelKey][index][parentKey][key] == quarter[fbForecastMIVResponseModelKey][index][parentKey][key]
            )// @ts-ignore
              ? quarter[fbForecastMIVResponseModelKey][index][parentKey][key]
              : 'Multiple %';
            month[fbForecastMIVResponseModelKey][index][parentKey][key] = month.weekList.every(// @ts-ignore
              (row: any) => month[fbForecastMIVResponseModelKey][index][parentKey][key] == row[fbForecastMIVResponseModelKey][index][parentKey][key]
              ) ? month[fbForecastMIVResponseModelKey][index][parentKey][key] : 'Multiple %';
          }
          if (key.indexOf('Comment') < 0 && !spreadEqualMeasures.includes(key)) {
            if (multipleAggregatedMeasures.includes(key)) {
              // Set Multiple on Month Level if values are different at week level

              const isSameMonthValue = month.weekList.every((row: any) => Number(row[fbForecastMIVResponseModelKey][index][parentKey][key]) == Number(month[fbForecastMIVResponseModelKey][index][parentKey][key]));
              month[fbForecastMIVResponseModelKey][index][parentKey][key] = isSameMonthValue ? month[fbForecastMIVResponseModelKey][index][parentKey][key] : 'Multiple';

              // Set Multiple on Quarter Level if values are different at month level

              const isSameQuarterValue = quarter.monthList.every((row: any) => row[fbForecastMIVResponseModelKey][index][parentKey][key] == quarter[fbForecastMIVResponseModelKey][index][parentKey][key])
              quarter[fbForecastMIVResponseModelKey][index][parentKey][key] = isSameQuarterValue ? quarter[fbForecastMIVResponseModelKey][index][parentKey][key]: 'Multiple';

            } else {
              month[fbForecastMIVResponseModelKey][index][parentKey][key] = month[fbForecastMIVResponseModelKey][index][parentKey][key];
              quarter[fbForecastMIVResponseModelKey][index][parentKey][key] = quarter[fbForecastMIVResponseModelKey][index][parentKey][key];
            }
            // @ts-ignore
          }
        });
      });
    }
  }
  return quarter;
}
